import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../assets/page-image/dqly/banner.jpg';
import _imports_1 from '../assets/page-image/dqly/djyd_link1.jpg';
import _imports_2 from '../assets/page-image/dqly/20da.png';
import _imports_3 from '../assets/page-image/dqly/djxxjy.png';
import _imports_4 from '../assets/page-image/dqly/xsdzgtsshzy.png';
import _imports_5 from '../assets/page-image/dqly/zywy.png';
const _hoisted_1 = {
  class: "dqly-wrapper"
};
const _hoisted_2 = {
  class: "dqly-page"
};
const _hoisted_3 = {
  class: "section"
};
const _hoisted_4 = {
  key: 0,
  class: "loading"
};
const _hoisted_5 = {
  key: 1,
  class: "card-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "card-image"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  class: "card-title"
};
const _hoisted_10 = {
  class: "card-date"
};
const _hoisted_11 = {
  class: "bottom-layout"
};
const _hoisted_12 = {
  class: "left-section"
};
const _hoisted_13 = {
  class: "horizontal-sections"
};
const _hoisted_14 = {
  class: "section half-section"
};
const _hoisted_15 = {
  key: 0,
  class: "loading"
};
const _hoisted_16 = {
  key: 1,
  class: "title-list"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  class: "title-text"
};
const _hoisted_19 = {
  class: "section half-section"
};
const _hoisted_20 = {
  key: 0,
  class: "loading"
};
const _hoisted_21 = {
  key: 1,
  class: "title-list"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "title-text"
};
const _hoisted_24 = {
  class: "section"
};
const _hoisted_25 = {
  key: 0,
  class: "loading"
};
const _hoisted_26 = {
  class: "culture-image"
};
const _hoisted_27 = ["src", "alt"];
const _hoisted_28 = {
  class: "culture-content"
};
const _hoisted_29 = {
  class: "culture-title"
};
const _hoisted_30 = {
  class: "culture-date"
};
const _hoisted_31 = {
  class: "culture-summary"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getColumnPage } from '@/api/party';
export default /*@__PURE__*/_defineComponent({
  __name: 'Dqly',
  setup(__props) {
    const router = useRouter();
    // 党建动态
    const partyList = ref([]);
    const loadingParty = ref(false);
    // 规章制度
    const rulesList = ref([]);
    const loadingRules = ref(false);
    // 通知公告
    const noticeList = ref([]);
    const loadingNotice = ref(false);
    // 创新文化
    const cultureItem = ref(null);
    const loadingCulture = ref(false);
    // 获取党建动态列表
    const getPartyList = async () => {
      loadingParty.value = true;
      try {
        const res = await getColumnPage({
          categoryId: 48,
          // 48-党群动态
          pageNum: 1,
          pageSize: 3
        });
        partyList.value = res.data || [];
      } catch (error) {
        console.error('获取党建动态列表失败:', error);
      } finally {
        loadingParty.value = false;
      }
    };
    // 获取规章制度列表
    const getRulesList = async () => {
      loadingRules.value = true;
      try {
        const res = await getColumnPage({
          categoryId: 49,
          // 49-规章制度
          pageNum: 1,
          pageSize: 10
        });
        rulesList.value = res.data || [];
      } catch (error) {
        console.error('获取规章制度列表失败:', error);
      } finally {
        loadingRules.value = false;
      }
    };
    // 获取通知公告列表
    const getNoticeList = async () => {
      loadingNotice.value = true;
      try {
        const res = await getColumnPage({
          categoryId: 50,
          // 50-通知公告
          pageNum: 1,
          pageSize: 10
        });
        noticeList.value = res.data || [];
      } catch (error) {
        console.error('获取通知公告列表失败:', error);
      } finally {
        loadingNotice.value = false;
      }
    };
    // 获取创新文化
    const getCultureItem = async () => {
      loadingCulture.value = true;
      try {
        const res = await getColumnPage({
          categoryId: 51,
          // 51-创新文化
          pageNum: 1,
          pageSize: 1
        });
        if (res.data && res.data.length > 0) {
          cultureItem.value = res.data[0];
        }
      } catch (error) {
        console.error('获取创新文化失败:', error);
      } finally {
        loadingCulture.value = false;
      }
    };
    // 格式化日期
    const formatDate = dateStr => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    // 跳转到详情页
    const goToDetail = id => {
      router.push(`/dqlyDetail/${id}`);
    };
    // 点击更多按钮
    const goToMore = categoryId => {
      router.push({
        path: '/dqlyList',
        query: {
          categoryId: categoryId.toString()
        }
      });
    };
    // 页面加载时获取数据
    onMounted(() => {
      getPartyList();
      getRulesList();
      getNoticeList();
      getCultureItem();
    });
    return (_ctx, _cache) => {
      const _component_BlueSectionTitle = _resolveComponent("BlueSectionTitle");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "党群园地",
        class: "banner"
      })])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_BlueSectionTitle, {
        title: "党建动态",
        showMore: true,
        onMoreClick: _cache[0] || (_cache[0] = $event => goToMore(48)),
        class: "blue-title"
      }), loadingParty.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, "加载中...")) : (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partyList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "card-item",
          key: item.id,
          onClick: $event => goToDetail(item.id)
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          src: item.coverImage || '../assets/page-image/dqly/item-iamge.png',
          alt: item.title
        }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(formatDate(item.publishTime)), 1)], 8, _hoisted_6);
      }), 128))]))]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_BlueSectionTitle, {
        title: "规章制度",
        showMore: true,
        onMoreClick: _cache[1] || (_cache[1] = $event => goToMore(49)),
        class: "blue-title"
      }), loadingRules.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, "加载中...")) : (_openBlock(), _createElementBlock("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rulesList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "title-item",
          key: item.id,
          onClick: $event => goToDetail(item.id)
        }, [_cache[5] || (_cache[5] = _createElementVNode("span", {
          class: "dot"
        }, null, -1)), _createElementVNode("span", _hoisted_18, _toDisplayString(item.title), 1)], 8, _hoisted_17);
      }), 128))]))]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_BlueSectionTitle, {
        title: "通知公告",
        showMore: true,
        onMoreClick: _cache[2] || (_cache[2] = $event => goToMore(50)),
        class: "blue-title"
      }), loadingNotice.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, "加载中...")) : (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "title-item",
          key: item.id,
          onClick: $event => goToDetail(item.id)
        }, [_cache[6] || (_cache[6] = _createElementVNode("span", {
          class: "dot"
        }, null, -1)), _createElementVNode("span", _hoisted_23, _toDisplayString(item.title), 1)], 8, _hoisted_22);
      }), 128))]))])]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_BlueSectionTitle, {
        title: "创新文化",
        showMore: true,
        onMoreClick: _cache[3] || (_cache[3] = $event => goToMore(51)),
        class: "blue-title"
      }), loadingCulture.value ? (_openBlock(), _createElementBlock("div", _hoisted_25, "加载中...")) : cultureItem.value ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "culture-item",
        onClick: _cache[4] || (_cache[4] = $event => goToDetail(cultureItem.value.id))
      }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
        src: cultureItem.value.coverImage || '../assets/page-image/dqly/item-iamge.png',
        alt: cultureItem.value.title
      }, null, 8, _hoisted_27)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(cultureItem.value.title), 1), _createElementVNode("div", _hoisted_30, _toDisplayString(formatDate(cultureItem.value.publishTime)), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(cultureItem.value.summary), 1)])])) : _createCommentVNode("", true)])]), _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"right-section\" data-v-3ef1786e><a href=\"http://jhsjk.people.cn/\" target=\"_blank\" class=\"right-link\" data-v-3ef1786e><img src=\"" + _imports_1 + "\" alt=\"党建园地\" class=\"right-image right-xjp\" data-v-3ef1786e></a><a href=\"https://www.12371.cn/special/xg20djs/\" target=\"_blank\" class=\"right-link\" data-v-3ef1786e><img src=\"" + _imports_2 + "\" alt=\"20大\" class=\"right-image\" data-v-3ef1786e></a><a href=\"https://www.12371.cn/djxx/\" target=\"_blank\" class=\"right-link\" data-v-3ef1786e><img src=\"" + _imports_3 + "\" alt=\"党建学习教育\" class=\"right-image\" data-v-3ef1786e></a><a href=\"https://www.12371.cn/xxsx/\" target=\"_blank\" class=\"right-link\" data-v-3ef1786e><img src=\"" + _imports_4 + "\" alt=\"学习党的二十大精神\" class=\"right-image\" data-v-3ef1786e></a><a href=\"https://www.12371.cn/special/20jszqh/\" target=\"_blank\" class=\"right-link\" data-v-3ef1786e><img src=\"" + _imports_5 + "\" alt=\"重要文件\" class=\"right-image\" data-v-3ef1786e></a></div>", 1))])]), _createVNode(_component_Footer)]);
    };
  }
});